module.exports = "<svg id=\"__1Dm1det__57668381-733c-408b-b15b-91332ee24394\" data-name=\"About\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\"><title>donauhof</title><path d=\"M18,34V5.51m-7.07,7.14H25.07M3.87,19.75a14.13,14.13,0,1,0,28.26,0M18,2a1.78,1.78,0,1,0,1.77,1.78A1.77,1.77,0,0,0,18,2ZM7.48,22.77l-3.61-3-3,3.63m34.3,0-3-3.63-3.61,3\" style=\"fill:none;stroke:#da9533;stroke-miterlimit:10\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/donauhof-about.svg
// module id = 400
// module chunks = 1